import { Column } from "primereact/column";
import { DataTable as PrimeDataTable } from "primereact/datatable";
import { useState, forwardRef, useImperativeHandle, useRef, useEffect } from "react";

const DataTable = forwardRef((props: any, ref) => {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const dtRef = useRef<any>(null);

  useEffect(() => {
    setSelectedRows([]);
  }, [props.value]);

  useImperativeHandle(
    ref,
    () => ({
      ...(dtRef.current || {}),
      getSelectedRows: () => selectedRows,
      clearSelectedRows: () => setSelectedRows([]),
    }),
    [selectedRows, dtRef.current]
  );

  return (
    <PrimeDataTable
      ref={dtRef}
      className="w-full"
      paginator
      rows={50}
      rowsPerPageOptions={[10, 25, 50]}
      showGridlines
      stripedRows
      removableSort
      filterDisplay="row"
      size="small"
      selectionMode="multiple"
      selection={selectedRows}
      onSelectionChange={(e) => setSelectedRows(e.value)}
      {...props}
    >
      <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
      {props.children}
    </PrimeDataTable>
  );
});

export { DataTable };
